import * as React from 'react';
import classNames from 'classnames';
import { useField } from 'formik';
import { useTranslation } from 'client/hooks';
import css from './TextFieldInput.module.scss';

interface Props {
  classname?: string;
  name?: string;
  placeholder?: string;
  onChange?: (evt: any) => void;
  type?: string;
  pattern?: RegExp;
}

const TextFieldInput: React.FC<Props> = (props) => {
  const { classname = '', name = '', placeholder = '', onChange, type = '', pattern, ...rest } = props;
  const [field, meta, helpers] = useField(name);
  const { translate } = useTranslation('errors');

  const onInputChange = (e: any) => {
    if (pattern) {
      if (e.target.value === '' || pattern.test(e.target.value.toLocaleLowerCase())) {
        helpers.setValue(e.target.value);
      }
    } else {
      helpers.setValue(e.target.value);
    }
  };

  return (
    <div className={css.container}>
      <input className={classNames(css.formInput, classname)} {...field} type={type} onChange={onInputChange} />
      {!field.value && <p className={css.placeholder} dangerouslySetInnerHTML={{ __html: placeholder }}></p>}
      <span>{meta.error && meta.touched ? translate(`${name}.${meta.error}`) : ''}</span>
    </div>
  );
};

export default TextFieldInput;
